import React, { useState, useEffect, useRef } from 'react'
import { Outlet, useParams, useNavigate } from 'react-router-dom'
// material
import { TextField, FormControl, Box, Button as MButton, IconButton, Tabs, Tab, Popover } from '@mui/material'
import { styled } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import toast from 'react-hot-toast'
import ReportGraph from '../../pages/ReportGraph'
import EmptyChart from './EmptyChart';
import StaticGraphTypesConfig from '../../layouts/graph/StaticGraphTypesConfig'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import _ from 'lodash';
import { getReportById, validateUserReport } from '../../config/services/reports'
import { containsSpecialCharacter, isMobileView } from '../../utils/Reusables';
import Grid from "@mui/material/Grid";
import Limit from '../../components/common/Limit';
import FilterSelectValue from '../../components/_report/cards/FilterSelectValue';
import FilterMultipleSelectValue from '../../components/_report/cards/FilterMultipleSelectValue';
import { handleLanguageChange } from "../../utils/multiLangDashboardV2Data";

import { LimitAllowedIn } from '../../constants/chartType';
import GraphTypesConfig from '../../layouts/graph/GraphTypesConfig';
import { ReactComponent as GraphIcon } from "../../assets/icons/graph-icon.svg"
import { ReactComponent as TableIcon } from "../../assets/icons/table-icon.svg"
import CloseIcon from "../../assets/icons/icon_close.svg";
import DatePicker from "react-datepicker";
import moment from 'moment';
import { ReactComponent as CalendarIcon } from "../../assets/icons/icon_calender.svg";

import { NumberChartTitleLength, NumberChartDescriptionLength } from "../../constants/stringParams";
import { handleStringLength } from "../../utils/multiLangDashboardV2Data";
import { CarouselPrevArrow, CarouselNextArrow } from "./../../utils/Reusables";
import Slider from "react-slick";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/swiper.min.css'
import 'swiper/modules/navigation/navigation.min.css';

// ----------------------------------------------------------------------
const RootStyle = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
})

const MainStyleWrapper = styled('div')(({ theme }) => ({
    height: '100%',
    width: '100%',
    paddingTop: '0 !important'
}))

const MainStyle = styled('div')(({ theme }) => ({
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    paddingTop: '0.5rem',
    paddingBottom: '2.5rem',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('lg')]: {
        paddingTop: '0.5rem',
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
        paddingBottom: '3rem',
    },
}))

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: "10%",
        width: "100"
    },
    graphFiltergrid: {
        [theme.breakpoints.down('sm')]: {
            marginTop: '0rem',
            '& > .MuiGrid-item': {
                paddingTop: 0,
            },
        },
    }
}))


// ----------------------------------------------------------------------

export default function ReportView(props) {
    const navigate = useNavigate()
    const UrlParams = useParams()
    const classes = useStyles();
    const [reportDetails, setReportDetails] = useState(null)
    const [pivotConfig, setPivotConfig] = useState({
        xAxis: { id: "xAxis", list: [], type: "dimensions" },
        value: { id: "value", list: [{ id: "1", text: "measures", type: "measures" }] },
    })
    const [gridColumnApi, setGridColumnApi] = useState(null);
    let [measureTitle, setMeasureTitle] = useState({})
    let [dimensionTitle, setDimensionTitle] = useState({})
    const reportContainerRef = useRef(null);


    const [filterInputEl, setFilterInputEl] = React.useState(null);
    const [filterInputOpen, setFilterInputOpen] = React.useState(false);
    const filterInputId = filterInputOpen ? 'simple-popover' : undefined;
    const selectFiltersInput = useRef(null);
    const [selectFilterWidth, setSelectFilterWidth] = useState('200px');
    const [startDatePickerPosition, setStartDatePickerPosition] = useState('bottom');
    const [endDatePickerPosition, setEndDatePickerPosition] = useState('bottom');
    const [isStartDatepickerOpen, setIsStartDatepickerOpen] = useState(false);
    const [isEndDatepickerOpen, setIsEndDatepickerOpen] = useState(false);


    const [filterInputSingleDateEl, setFilterInputSingleDateEl] = React.useState(null);
    const [filterInputSingleDateOpen, setFilterInputSingleDateOpen] = React.useState(false);
    const filterInputSingleDateId = filterInputSingleDateOpen ? 'simple-popover-single' : undefined;
    const selectFiltersSingleDateInput = useRef(null);
    const [selectFilterSingleDateWidth, setSelectFilterSingleDateWidth] = useState('200px');
    const [singleDateVal, setSingleDateVal] = useState(null);
    const [isSingleDatepickerOpen, setIsSingleDatepickerOpen] = useState(false);

    const [reportGridBgColor, setReportGridBgColor] = useState(null);
    const [reportHasBgColor, setReportHasBgColor] = useState(null);
    const [reportBgColor, setReportBgColor] = useState(null);
    const [reportBorderColor, setReportBorderColor] = useState(null);
    const [reportHasBorder, setReportHasBorder] = useState(null);
    const [reportCarouselElevationColor, setReportCarouselElevationColor] = useState(null);
    const [reportCarouselCardElevationColor, setReportCarouselCardElevationColor] = useState(null);
    //const [reportIsCarouselCardTitle, setReportIsCarouselCardTitle] = useState(null);
    const [reportCarouselCardSpacing, setReportCarouselCardSpacing] = useState('0');
    const [reportHasCarouselElevation, setReportHasCarouselElevation] = useState(null);
    const [reportHasCarouselCardElevation, setReportHasCarouselCardElevation] = useState(null);

    const chartContainerRef = useRef(null);
    const [chartContainerWidth, setChartContainerWidth] = useState(0);

    useEffect(() => {
        window.addEventListener('resize', chartResize);
        if(chartContainerRef?.current){
        setChartContainerWidth(chartContainerRef?.current?.clientWidth);
        }
    }, [chartContainerRef?.current]);

    const chartResize = () => {
        if(chartContainerRef && chartContainerRef?.current){
        setChartContainerWidth(chartContainerRef?.current?.clientWidth);
        }
    }

    const handleFilterInputSingleDateClick = (event) => {
        setSelectFilterWidth(selectFiltersInput.current.clientWidth);
        if (event.currentTarget != filterInputEl) setFilterInputEl(event.currentTarget);
        if (!filterInputOpen) setFilterInputOpen(true);
    };
    const handleFilterInputSingleDateClose = () => {
        setFilterInputEl(null);
        setFilterInputOpen(false);
    };

    let element = reportContainerRef.current || document.body;
    const [selectedReportTab, setSelectedReportTab] = useState(0);


    const updateReportDetails = (value) => {
        setReportDetails(value)
    }

    const convertPivotConfig = (pivot, result) => {

        let config = {
            xAxis: {
                id: "xAxis",
                list: [],
                label: 'X Axis'
            },
            value: {
                id: "value",
                list: [],
                label: 'Value'
            },
            lines: {
                id: "Lines",
                list: [],
                label: 'Lines'
            },
            // group: {
            //   id: "group",
            //   list: [],
            //   label: 'Group'
            // },
        }

        config.lines.list = pivot?.lines || []

        if (!pivot?.x?.length && !pivot?.y?.length && result && result?.dimensions?.length) {

            let dimensions = result?.dimensions.map((dim) => {
                return { text: dim?.fieldName, type: 'dimensions', id: dim?.fieldId }
            });
            config.xAxis.list = dimensions;
            config.value.list = [{ id: "1", text: "measures", type: "measures" }]
            return config;
        }
        else {
            const xArr = pivot?.x;
            const yArr = pivot?.y;
            let measures = xArr.map((meas) => {
                return { text: meas, type: 'measures', id: Math.floor(Math.random() * 1000).toString() }
            });
            let dimensions = yArr.map((dim) => {
                return { text: dim, type: 'dimensions', id: Math.floor(Math.random() * 1000).toString() }
            });

            config.xAxis.list = measures;
            config.value.list = dimensions;
            return config;
        }
    }

    const viewLinkedReportCarousel = (newValue) => {
        if (reportDetails?.reportDetails?.linkedReports?.[newValue - 1]?.reportId) {
            formatReportTitle(reportDetails?.reportDetails?.linkedReports?.[newValue - 1]?.reportId)
        }
        setSelectedReportTab(newValue)
    }

    const viewLinkedReport = (e, newValue) => {
        if (reportDetails?.reportDetails?.linkedReports?.[newValue - 1]?.reportId) {
            formatReportTitle(reportDetails?.reportDetails?.linkedReports?.[newValue - 1]?.reportId)
        }
        setSelectedReportTab(newValue)
    }

    const formatOrderBy = (order, result) => {
        if (order && result) {
            const orderBy = Object.entries(order).map(([key, val]) => {
                return {
                    id: Math.floor(Math.random() * 1000).toString(),
                    content: {
                        key: result?.dataSetId?.dataSetName + "." + key,
                        order: val
                    }
                }
            });
            return orderBy;
        }
        else if (!order?.length && result) {
            let order = [];
            if (result?.dimensions?.length) {
                for (let dim of result?.dimensions) {
                    let obj = {
                        id: dim?.fieldId,
                        content: {
                            key: dim?.fieldName,
                            order: 'asc'
                        }
                    }
                    order.push(obj)
                }
            }
            if (result?.measures?.length) {
                for (let meas of result?.measures) {
                    let obj = {
                        id: meas?.fieldId,
                        content: {
                            key: meas?.fieldName,
                            order: 'desc'
                        }
                    }
                    order.push(obj)
                }
            }
            return order;
        }

    }

    const handleMeasureFieldFormat = (measures) => {
        const formatObj = {}
        if (measures && measures.length) {
            measures.forEach(ele => {
                const { fieldName, fieldFormat } = ele;
                if (fieldFormat) {
                    formatObj[fieldName] = fieldFormat;
                }
            })
        }
        return formatObj;
    }


    const fetchReportById = () => {
        let { id } = UrlParams

        let params = { reportId: id }
        validateUserReport(params).then(resp => {
            if (resp && resp.length) {
                getReportById(params)
                    .then((res) => {
                        const pivotConfig = convertPivotConfig(res?.result?.pivotConfig, res?.result);
                        const orderBy = formatOrderBy(res?.result?.orderBy, res?.result);
                        res.result.pivotConfig = pivotConfig;
                        res.result.orderBy = orderBy;
                        formatReportTitle(res?.result)
                        res.result.linkedReports = mapLinkedResponseData(res.result)
                        res.result.renewQuery = false
                        res.result.settings.conditionalFormat = res.result.settings.conditionalFormat || [{}]
                        res.result.settings.pageSize = res.result.settings.pageSize || 10
                        res.result.settings.alignment = res.result.settings.alignment || { header: 'left', dimensions: 'left' }
                        res.result.settings.rateChangeProps = res.result.settings.rateChangeProps || {}

                        setReportDetails({ reportDetails: res.result })

                    })
            }
            else {
                navigate('/report')
            }
        })
    }

    const formatReportTitle = (data) => {
        let dimensionTitle = {};
        let measureTitle = {};

        data?.dimensions?.map(dim => {
            let key = dim?.fieldName;
            dimensionTitle[key] = dim?.title
        })
        data?.measures?.map(meas => {
            let key = meas?.fieldName;
            measureTitle[key] = meas?.title
        });

        setMeasureTitle(measureTitle)
        setDimensionTitle(dimensionTitle)
    }

    useEffect(() => {
        setReportDetails(reportDetails);
        setPivotConfig(pivotConfig);
    }, [pivotConfig])


    const handleDateFormatField = (dimensions) => {
        let dateFormat = {};
        dimensions.map(dim => {
            if (dim?.dateFormat) {
                dateFormat[dim?.fieldName] = dim?.dateFormat
            }
        })
        return dateFormat;
    }

    const mapLinkedResponseData = (reportData) => {
        let clonedReportData = _.cloneDeep(reportData)
        return clonedReportData?.linkedReports?.map(reportObj => {
            const pivotConfig = convertPivotConfig(reportObj?.reportId?.pivotConfig, reportObj?.reportId);
            const orderBy = formatOrderBy(reportObj?.reportId?.orderBy, reportObj?.reportId);

            reportObj.reportName = reportObj?.reportId?.reportName
            reportObj.reportId.pivotConfig = pivotConfig;
            reportObj.reportId.orderBy = orderBy;

            return reportObj
        })
    }


    const getHiddenFields = (fields) => {
        let fieldsArr = []
        if (fields.length) {
            for (let field of fields) {
                if (field?.isHidden) {
                    fieldsArr.push(field?.fieldName)
                }
            }
        }
        return fieldsArr;
    }


    const handleReportFields = (reportFields) => {
        let fieldsArr = []
        if (reportFields.length) {
            for (let fields of reportFields) {
                // if (!fields?.isHidden) {
                fieldsArr.push(fields?.fieldName)
                // }
            }
        }
        return fieldsArr;
    }

    useEffect(() => fetchReportById(), [])


    const getReportFieldsKey = () => {
        let info = { measureKey: [], dimensionKey: [] }
        if (reportDetails?.reportDetails?.measures.length) {
            info.measureKey = reportDetails?.reportDetails?.measures.map(meas => meas?.fieldName)
        }
        if (reportDetails?.reportDetails?.dimensions.length) {
            info.dimensionKey = reportDetails?.reportDetails?.dimensions.map(dim => dim?.fieldName)
        }
        return info
    }

    const mapResponseForQuery = (reportDetailsQuery) => {
        let tempQuery = { vizState: {} }
        tempQuery.name = reportDetailsQuery?.reportName
        const dateFormat = handleDateFormatField(reportDetailsQuery?.dimensions)
        const colDisplayName = handleColumnDisplayName(reportDetailsQuery)
        const fieldFormat = handleMeasureFieldFormat(reportDetailsQuery?.measures)

        tempQuery.vizState = {
            chartType: reportDetailsQuery?.chartType,
            query: {
                measures: handleReportFields(reportDetailsQuery?.measures),
                order: handleQueryOrderBy(reportDetailsQuery?.orderBy),
                dimensions: handleReportFields(reportDetailsQuery?.dimensions),
                limit: reportDetailsQuery?.limit,
                timeDimensions: reportDetailsQuery?.timeDimensions,
                filters: reportDetailsQuery?.reportFilters?.filter((item) => {
                    if (item.operator === 'set' || item.operator === 'notSet') {
                        return { member: item.member, operator: item.operator }
                    }
                    if (item?.member && item?.operator && item?.values?.length > 0)
                        return { member: item.member, operator: item.operator, values: item.values }
                }),
                renewQuery: reportDetailsQuery?.renewQuery

            },
            pivotConfig: handlePivotConfigFormat(reportDetailsQuery?.pivotConfig),
            columnState: reportDetailsQuery?.columnState,
            isPivotEnabled: reportDetailsQuery?.isPivotEnabled,
            isLegendVisible: reportDetailsQuery?.isLegendVisible,
            legendPosition: reportDetailsQuery?.legendPosition,
            columnTitle: [{ ...dimensionTitle, ...measureTitle }],
            dateFieldFormat: dateFormat,
            columnDisplayName: colDisplayName,
            noDataText: reportDetailsQuery?.noDataText,
            fieldFormat: fieldFormat,
            reportHyperlink: reportDetailsQuery?.reportHyperlink || [],
            settings: reportDetailsQuery?.settings,
            toggleToTable: reportDetailsQuery?.toggleToTable,
            viewMode: 'report',
            reportName: reportDetailsQuery?.reportName,
            description: reportDetailsQuery?.description,
            fieldsKeyInfo: getReportFieldsKey(),
            hiddenFields: getHiddenFields([...reportDetailsQuery?.measures, ...reportDetailsQuery?.dimensions])
        }
        tempQuery.vizState.query.filters = tempQuery.vizState.query.filters?.map((item) => {
            if (item.operator === 'set' || item.operator === 'notSet') {
                return { member: item.member, operator: item.operator }
            }
            if (item?.member && item?.operator && item?.values?.length > 0)
                return { member: item.member, operator: item.operator, values: item.values }
        })
        return tempQuery
    }

    const handleQueryOrderBy = (order) => {
        let orderBy = {};
        order?.forEach(ele => {
            orderBy[ele.content.key] = ele?.content?.order;
        })
        return orderBy;
    }

    const handlePivotConfigFormat = (pivot) => {
        const xArr = pivot?.xAxis?.list.map(ele => ele.text)
        const yArr = pivot?.value?.list.map(ele => ele.text)
        const lines = pivot?.lines?.list
        // const group = pivot?.group?.list

        const config = {
            x: xArr,
            y: yArr,
            lines,
            // group,
        }
        return config
    }

    const handleColumnDisplayName = (report) => {
        const measures = report?.measures;
        const dimensions = report?.dimensions;
        const displayObj = {};

        if (measures && measures.length) {
            measures.forEach(ele => {
                const { fieldName, displayName } = ele;
                if (displayName) {
                    displayObj[fieldName] = displayName;
                }
            })
        }
        if (dimensions && dimensions.length) {
            dimensions.forEach(ele => {
                const { fieldName, displayName } = ele;
                if (displayName) {
                    displayObj[fieldName] = displayName;
                }
            })
        }
        return displayObj;
    }

    const handleChangeFilterFromList = (obj, index, e) => {
        e.target.value = typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value;

        reportDetails.reportDetails.reportFilters[index].values = e.target.value;

        updateReportDetails({ reportDetails: reportDetails.reportDetails });
    }

    const handleDateFilter = (e, obj, i, dateType) => {
        let value = e
        let newDates = [...obj.values]

        if (dateType === 'startDate') {
            newDates[0] = value;
        } else if (dateType === 'endDate') {
            newDates[1] = value;
        } else if (dateType === 'singleDate') {
            newDates[0] = value;
        }
        if (newDates[0] && newDates[1]) {
            const startDate = new Date(newDates[0]);
            const timestamp1 = startDate.getTime();

            const endDate = new Date(newDates[1]);
            const timestamp2 = endDate.getTime();

            if (timestamp1 && timestamp2 && (timestamp1 > timestamp2)) {
                // [newDates[0], newDates[1]] = [newDates[1], newDates[0]];
                toast.error("Start Date cannot be after End Date")
                return
            }
        }

        if (newDates[0] && newDates[1]) {
            const startDate = new Date(newDates[0]);
            const timestamp1 = startDate.getTime();

            const endDate = new Date(newDates[1]);
            const timestamp2 = endDate.getTime();

            if (timestamp1 && timestamp2 && (timestamp1 > timestamp2)) {
                // [newDates[0], newDates[1]] = [newDates[1], newDates[0]];
                toast.error("End date cannot be smaller than start date")
                return
            }
        }
        reportDetails.reportDetails.reportFilters[i].values = newDates;
        updateReportDetails({ reportDetails: reportDetails.reportDetails });
    }

    const handleReportLimit = (e) => {
        let { value } = e.target
        if (value < 1) {
            toast.error("Limit cannot be less than 1");
        } else {
            reportDetails.reportDetails.limit = value
            updateReportDetails({ reportDetails: reportDetails.reportDetails })
        }
    }

    const convertToTable = () => {
        let clonedReportDetails = _.cloneDeep(reportDetails)
        let { linkedReports } = clonedReportDetails?.reportDetails

        if (selectedReportTab > 0 && linkedReports?.length && linkedReports?.[selectedReportTab - 1]?.reportId) {
            linkedReports[selectedReportTab - 1].reportId.toggleToTable = !linkedReports?.[selectedReportTab - 1]?.reportId.toggleToTable
        }
        else {
            clonedReportDetails.reportDetails.toggleToTable = !clonedReportDetails.reportDetails.toggleToTable
        }

        updateReportDetails({ reportDetails: clonedReportDetails.reportDetails })
    }

    const getPivotColState = () => {
        let colState = gridColumnApi?.getColumnState()
        return (colState ? colState : [])
    }

    const validateMeasuresDimension = ({ measures, dimensions, timeDimensions, chartType }) => {
        let measuresL = measures?.length || 0;
        let dimensionsL = (dimensions?.length || 0) + (timeDimensions?.length || 0);

        if (!(measuresL || dimensionsL))
            return false;

        const staticGraphType = StaticGraphTypesConfig.find((obj) => obj.value === chartType);

        if (staticGraphType) {
            const { operator, minDimension, minMeasure, maxDimension, maxMeasure } = staticGraphType?.requireField;

            if (operator) {
                if (operator === "minOr" && ((dimensionsL < minDimension) && (measuresL < minMeasure)))
                    return false;
                else if (operator === "minAnd_maxAnd" && !((dimensionsL >= minDimension) && (measuresL >= minMeasure)))
                    return false;
                else if (operator === "minAnd_maxAnd" && !((dimensionsL <= maxDimension) && (measuresL <= maxMeasure)))
                    return false;
                return true
            }
        }
        else {
            const graphType = GraphTypesConfig.find((obj) => obj.value === chartType);

            const { operator, minDimension, minMeasure, maxDimension, maxMeasure } = graphType?.requireField;

            if (operator) {
                if (operator === "minOr" && ((dimensionsL < minDimension) && (measuresL < minMeasure)))
                    return false;
                else if (operator === "minAnd_maxAnd" && !((dimensionsL >= minDimension) && (measuresL >= minMeasure)))
                    return false;
                else if (operator === "minAnd_maxAnd" && !((dimensionsL <= maxDimension) && (measuresL <= maxMeasure)))
                    return false;
            } else {
                if (minDimension && dimensionsL < minDimension)
                    return false;
                else if (minMeasure && measuresL < minMeasure)
                    return false;
                else if (maxDimension && dimensionsL > maxDimension)
                    return false;
                else if (maxMeasure && measuresL > maxMeasure)
                    return false;
            }
            return true;

        }
    }
    let { settings, toggleToTable, chartType, linkedReports, tabName, linkedReportsViewType, linkedReportsViewCount, linkedReportsViewCountMobile } = reportDetails?.reportDetails ?? {}


    const handleFilterInputClick = (event) => {
        setSelectFilterWidth(selectFiltersInput.current.clientWidth);
        if (event.currentTarget != filterInputEl) setFilterInputEl(event.currentTarget);
        if (!filterInputOpen) setFilterInputOpen(true);
        if (selectFiltersInput?.current) {
            const startDatePickerPos = window.innerHeight - selectFiltersInput.current.getBoundingClientRect().top - 160;
            if (startDatePickerPos >= 280) {
                setStartDatePickerPosition('bottom');
            } else {
                setStartDatePickerPosition('top');
            }
            const endDatePickerPos = window.innerHeight - selectFiltersInput.current.getBoundingClientRect().top - 200;
            if (endDatePickerPos >= 280) {
                setEndDatePickerPosition('bottom');
            } else {
                setEndDatePickerPosition('top');
            }
        }

    };
    const handleFilterInputClose = () => {
        setFilterInputEl(null);
        setFilterInputOpen(false);
        return false;
    };

    useEffect(() => {
        let rSettings = reportDetails?.reportDetails?.settings;
        let rBgColor;
        let rGridBgColor;
        let rBorderColor;
        let rIsBorder;
        let rIsCarouselElevation;
        let rCarouselElevationColor;
        let rIsCarouselCardTitle;
        let rCarouselCardSpacing;
        let rIsCarouselCardElevation;
        let rCarouselCardElevationColor;
        let rHasBgColor;
    
        if(isMobileView()) {
          rGridBgColor = rSettings?.mobile?.reportShowGridBackgroundColor ? rSettings?.mobile?.reportGridBgColor : null;
          rHasBgColor = rSettings?.mobile?.reportShowBackgroundColor;
          rBgColor = rSettings?.mobile?.reportShowBackgroundColor ? rSettings?.mobile?.reportBgColor : null;
          rBorderColor = rSettings?.mobile?.reportShowBorderColor ? rSettings?.mobile?.reportBorderColor : null;
          rIsBorder = rSettings?.mobile?.reportShowBorderColor;
          rIsCarouselElevation = rSettings?.mobile?.reportIsCarouselElevation || 0;
          rCarouselElevationColor = rSettings?.mobile?.reportIsCarouselElevation ? rSettings?.mobile?.reportCarouselElevationColor : null;
          rIsCarouselCardTitle = rSettings?.mobile?.reportIsCarouselCardTitle;
          rCarouselCardSpacing = rSettings?.mobile?.reportCarouselCardSpacing || '0';
          rIsCarouselCardElevation = rSettings?.mobile?.reportIsCarouselCardElevation || 0;
          rCarouselCardElevationColor = rSettings?.mobile?.reportIsCarouselCardElevation ? rSettings?.mobile?.reportCarouselCardElevationColor : null;
    
         } else {
          rGridBgColor = rSettings?.web?.reportShowGridBackgroundColor ? rSettings?.web?.reportGridBgColor : null;
          rHasBgColor = rSettings?.mobile?.reportShowBackgroundColor;
          rBgColor = rSettings?.web?.reportShowBackgroundColor ? rSettings?.web?.reportBgColor : null;
          rBorderColor = rSettings?.web?.reportShowBorderColor ? rSettings?.web?.reportBorderColor : null;
          rIsBorder = rSettings?.web?.reportShowBorderColor;
          rIsCarouselElevation = rSettings?.web?.reportIsCarouselElevation || 0;
          rCarouselElevationColor = rSettings?.web?.reportIsCarouselElevation ? rSettings?.web?.reportCarouselElevationColor : null;
          rIsCarouselCardTitle = rSettings?.web?.reportIsCarouselCardTitle;
          rCarouselCardSpacing = rSettings?.web?.reportCarouselCardSpacing || '0';
          rIsCarouselCardElevation = rSettings?.web?.reportIsCarouselCardElevation || 0;
          rCarouselCardElevationColor = rSettings?.web?.reportIsCarouselCardElevation ? rSettings?.web?.reportCarouselCardElevationColor : null;
        }
    
        setReportGridBgColor(rGridBgColor);
        setReportHasBgColor(rHasBgColor);
        setReportBgColor(rBgColor);
        setReportHasBorder(rIsBorder);
        setReportBorderColor(rBorderColor);
        //setReportIsCarouselCardTitle(rIsCarouselCardTitle);
        setReportCarouselCardSpacing(rCarouselCardSpacing);
        setReportCarouselElevationColor(rCarouselElevationColor);
        setReportCarouselCardElevationColor(rCarouselCardElevationColor);
        setReportHasCarouselElevation(rIsCarouselElevation);
        setReportHasCarouselCardElevation(rIsCarouselCardElevation);
    
    
      }, [reportDetails?.reportDetails?.settings]);
   

    return (
        <RootStyle>
            <MainStyleWrapper pt={0} className="report-view-wrapper report-page-wrapper">
                <Box mt={0} sx={{ flexGrow: 1 }}>

                    <Grid container className="report-new-content" >

                        <Grid item xs={12} sx={{ pt: 0 }} className="reports-embed-heading-section" >
                            <Grid container mb={2} className="report-new-header-container" >
                                <Grid container item alignItems="start" justifyContent="center" direction="column" className="reports-embed-header-content"
                                    sm={12} md={12} lg={6} order={{ lg: 1, md: 2, sm: 2, xs: 2 }} >
                                    <Typography variant="h2" noWrap>
                                        {reportDetails?.reportDetails?.reportName || ""}
                                    </Typography>
                                    <Typography variant="p" >
                                        {reportDetails?.reportDetails?.description}
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Grid>

                        <Grid item xs={12} mt={2} className="report-new-main-content" alignItems="stretch" >
                            <Grid className="report-new-main-content-section" sx={{ height: '100%' }}>
                                <MainStyle>
                                    <Outlet />

                                    {LimitAllowedIn.includes(reportDetails?.reportDetails?.chartType) && (reportDetails?.reportDetails?.measures?.length ||
                                        reportDetails?.reportDetails?.dimensions?.length) ? (
                                        <Limit handleReportLimit={handleReportLimit} limitValue={reportDetails?.reportDetails?.limit} />)
                                        : null}

                                    <Grid className={classes.graphFiltergrid} sx={{ marginBottom: '1rem' }} >
                                        <Box sx={{ flexGrow: 1 }}>
                                            <Box className="dashboard-view-filters-container" >
                                                {
                                                    reportDetails?.reportDetails?.reportFilters?.map((obj, i) => {
                                                        let displayName = !!(obj.displayName) ? obj.displayName : obj?.member?.split('.')[1];
                                                        return obj?.listType && (obj?.operator === "equals" || obj?.type === "time") ? (

                                                            obj.operator === "inDateRange" || obj.operator === "notInDateRange" ?
                                                                <>
                                                                    <Box key={i} className="dashboard-filters-view-item" >
                                                                        <Box>
                                                                            <FormControl className="select-filters" variant="outlined" sx={{ width: '100%' }} size="small" >
                                                                                <Box className="select_filters_input" onClick={handleFilterInputClick} ref={selectFiltersInput}>
                                                                                    <Box className="select_filters_input_item" display="flex" alignItems="center">
                                                                                        <Typography className={"label-font "}>Select Date Range</Typography>
                                                                                    </Box>
                                                                                    <Box className="select_filters_input_item"><CalendarIcon className="cr-form-date-icon" /></Box>
                                                                                </Box>
                                                                                <Popover
                                                                                    id={filterInputId}
                                                                                    open={filterInputOpen}
                                                                                    anchorEl={filterInputEl}
                                                                                    onClose={handleFilterInputClose}
                                                                                    anchorOrigin={{
                                                                                        vertical: 'bottom',
                                                                                        horizontal: 'left',
                                                                                    }}
                                                                                    PaperProps={{
                                                                                        classes: {
                                                                                            root: 'filter-item-options'
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <Box className="filters-dropdown-item" sx={{ width: selectFilterWidth }}>
                                                                                        <Box className="filters-dropdown-item-header">
                                                                                            <Box className="select_filters_input_item">
                                                                                                <Typography className="filters-dropdown-item-label" sx={{ pl: '0 !important' }} >{obj?.displayNameOnSheet || obj?.member?.split('.')[1]}</Typography>
                                                                                            </Box>
                                                                                            <Box className="select_filters_input_item">
                                                                                                <IconButton className="form-icon-btn filter-close-icon" color="secondary" onClick={handleFilterInputClose}>
                                                                                                    <img src={CloseIcon} className="" />
                                                                                                </IconButton>
                                                                                            </Box>
                                                                                        </Box>
                                                                                        <Box className="filters-dropdown-item-content" sx={{ p: '1rem !important' }} >
                                                                                            <Grid container spacing={2} >
                                                                                                <Grid xs={12} md={12} item >
                                                                                                    <Typography className="report-form-label" variant="subtitle2" >Start Date</Typography>
                                                                                                    <DatePicker
                                                                                                        shouldCloseOnSelect={true}
                                                                                                        dateFormat="dd/MM/yyyy HH:mm:ss"
                                                                                                        showYearDropdown={true}
                                                                                                        showMonthDropdown={true}
                                                                                                        dropdownMode="select"

                                                                                                        minDate={new Date("01-01-2021 00:00:00")}
                                                                                                        minTime={new Date("2021-01-01 00:00:00")}
                                                                                                        maxDate={new Date()}
                                                                                                        popperPlacement={startDatePickerPosition}
                                                                                                        popperModifiers={[
                                                                                                            {
                                                                                                                name: "offset",
                                                                                                                options: {
                                                                                                                    offset: [5, 10],
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                name: "preventOverflow",
                                                                                                                options: {
                                                                                                                    rootBoundary: "viewport",
                                                                                                                    tether: false,
                                                                                                                    altAxis: true,
                                                                                                                },
                                                                                                            },
                                                                                                        ]}
                                                                                                        onInputClick={() => setIsStartDatepickerOpen(true)}
                                                                                                        onClickOutside={() => setIsStartDatepickerOpen(false)}
                                                                                                        open={isStartDatepickerOpen}
                                                                                                        onKeyDown={(e) => {
                                                                                                            e.preventDefault();
                                                                                                        }}
                                                                                                        onChangeRaw={(e) => { e.preventDefault() }}
                                                                                                        className="report_form_ui_input_date" selected={obj?.values[0] ? new Date(obj?.values[0]) : null}
                                                                                                        onChange={(e) => handleDateFilter(e, obj, i, 'startDate')}
                                                                                                        isClearable
                                                                                                        placeholderText='Select Date' />
                                                                                                </Grid>
                                                                                                <Grid xs={12} md={12} item >
                                                                                                    <Typography className="report-form-label" variant="subtitle2" >End Date</Typography>
                                                                                                    <DatePicker dateFormat="dd/MM/yyyy HH:mm:ss"
                                                                                                        showYearDropdown={true}
                                                                                                        showMonthDropdown={true}
                                                                                                        dropdownMode="select"
                                                                                                        shouldCloseOnSelect={true}

                                                                                                        maxDate={new Date()}
                                                                                                        maxTime={new Date().setHours(23, 59, 59, 999)}
                                                                                                        minDate={new Date(obj?.values[0])}
                                                                                                        popperPlacement={endDatePickerPosition}
                                                                                                        popperModifiers={[
                                                                                                            {
                                                                                                                name: "offset",
                                                                                                                options: {
                                                                                                                    offset: [5, 10],
                                                                                                                },
                                                                                                            },
                                                                                                            {
                                                                                                                name: "preventOverflow",
                                                                                                                options: {
                                                                                                                    rootBoundary: "viewport",
                                                                                                                    tether: false,
                                                                                                                    altAxis: true,
                                                                                                                },
                                                                                                            },
                                                                                                        ]}
                                                                                                        onInputClick={() => setIsEndDatepickerOpen(true)}
                                                                                                        onClickOutside={() => setIsEndDatepickerOpen(false)}
                                                                                                        open={isEndDatepickerOpen}
                                                                                                        isClearable
                                                                                                        onKeyDown={(e) => {
                                                                                                            e.preventDefault();
                                                                                                        }}
                                                                                                        onChangeRaw={(e) => e.preventDefault()}
                                                                                                        className="report_form_ui_input_date" selected={obj?.values[1] ? new Date(obj?.values[1]) : null}
                                                                                                        onChange={(e) => handleDateFilter(e, obj, i, 'endDate')}
                                                                                                        placeholderText='Select Date' />
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        </Box>

                                                                                    </Box>
                                                                                </Popover>

                                                                            </FormControl>
                                                                        </Box>
                                                                    </Box>


                                                                </>
                                                                :
                                                                obj.operator === "beforeDate" || obj.operator === "afterDate" ?
                                                                    <>
                                                                        <Box className="dashboard-filters-view-item" >
                                                                            <Box>
                                                                                <FormControl className="select-filters" variant="outlined" sx={{ width: '100%' }} size="small" >
                                                                                    <Box className="select_filters_input" onClick={handleFilterInputSingleDateClick} ref={selectFiltersSingleDateInput} >
                                                                                        <Box className="select_filters_input_item" display="flex" alignItems="center">
                                                                                            <Typography className="label-font">{'Select Date'}</Typography>
                                                                                        </Box>
                                                                                        <Box className="select_filters_input_item"><CalendarIcon className="cr-form-date-icon" /></Box>
                                                                                    </Box>
                                                                                    <Popover
                                                                                        id={filterInputSingleDateId}
                                                                                        open={filterInputSingleDateOpen}
                                                                                        anchorEl={filterInputSingleDateEl}
                                                                                        onClose={handleFilterInputSingleDateClose}
                                                                                        anchorOrigin={{
                                                                                            vertical: 'bottom',
                                                                                            horizontal: 'left',
                                                                                        }}
                                                                                        PaperProps={{
                                                                                            classes: {
                                                                                                root: 'filter-item-options'
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <Box className="filters-dropdown-item" sx={{ width: selectFilterSingleDateWidth }}>
                                                                                            <Box className="filters-dropdown-item-header">
                                                                                                <Box className="select_filters_input_item">
                                                                                                    <Typography className="filters-dropdown-item-label" sx={{ pl: '0 !important' }} >{displayName}</Typography>
                                                                                                </Box>
                                                                                                <Box className="select_filters_input_item">
                                                                                                    <IconButton className="form-icon-btn filter-close-icon" color="secondary">
                                                                                                        <img src={CloseIcon} onClick={handleFilterInputSingleDateClose} className="" />
                                                                                                    </IconButton>
                                                                                                </Box>
                                                                                            </Box>
                                                                                            <Box className="filters-dropdown-item-content" sx={{ p: '1rem !important' }}>
                                                                                                <Grid container spacing={2} >
                                                                                                    <Grid xs={12} md={12} item >
                                                                                                        <Typography className="report-form-label" variant="subtitle2" >Date</Typography>
                                                                                                        <DatePicker dateFormat="dd/MM/yyyy HH:mm:ss"
                                                                                                            shouldCloseOnSelect={true}
                                                                                                            maxDate={new Date()}
                                                                                                            className="report_form_ui_input_date" selected={obj?.values[0] && moment(obj?.values[0]).toDate()}
                                                                                                            onChange={(e) => handleDateFilter(e, obj, i, 'singleDate')} isClearable
                                                                                                            onInputClick={() => setIsSingleDatepickerOpen(true)}
                                                                                                            onClickOutside={() => setIsSingleDatepickerOpen(false)}
                                                                                                            open={isSingleDatepickerOpen}
                                                                                                        />
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                            </Box>
                                                                                        </Box>
                                                                                    </Popover>
                                                                                </FormControl>

                                                                            </Box>
                                                                        </Box>


                                                                    </>
                                                                    :
                                                                    (obj?.listType === "dropdown" ?
                                                                        <Box className="dashboard-filters-view-item" >
                                                                            <Box>
                                                                                <FormControl className="select-filters" variant="outlined" sx={{ width: '100%' }} size="small" >
                                                                                    <FilterSelectValue handleChangeFilterFromList={handleChangeFilterFromList} filterCondtion={obj} i={i}
                                                                                        reportDetails={reportDetails}
                                                                                        updateReportDetails={updateReportDetails} />
                                                                                </FormControl>
                                                                            </Box>
                                                                        </Box>
                                                                        :
                                                                        <Box className="dashboard-filters-view-item" >
                                                                            <Box>
                                                                                <FormControl className="select-filters" variant="outlined" sx={{ width: '100%' }} size="small" >

                                                                                    <FilterMultipleSelectValue handleChangeFilterFromList={handleChangeFilterFromList} filterCondtion={obj} i={i}
                                                                                        reportDetails={reportDetails}
                                                                                        updateReportDetails={updateReportDetails} />
                                                                                </FormControl>
                                                                            </Box>
                                                                        </Box>
                                                                    )

                                                        ) : null
                                                    })
                                                }
                                            </Box>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} className="report-graph-section" ref={reportContainerRef} >
                                        <Box className={`report-graph-section-wrapper ` + ((reportBgColor) ? ` has-bg ` : ``) + ((reportHasBorder) ? ` has-border ` : ``) 
                                            + ((reportHasCarouselElevation) ? ` has-elevation ` : ``) + ((reportHasCarouselCardElevation) ? ` has-card-elevation ` : ``)} 
                                            sx={{ backgroundColor: (reportBgColor ? reportBgColor : 'transparent'), 
                                                    borderWidth: (reportHasBorder ? '1px' : '0px'), borderStyle: 'solid', 
                                                    borderColor: reportBorderColor ? reportBorderColor : 'transparent',
                                                    boxShadow: (reportHasCarouselElevation ? `0px 0px 6px ${reportCarouselElevationColor ?? '#DEDEDE'}` : 'none'),
                                                }}
                                            
                                            >
                                            <Box className='' display="flex" justifyContent="flex-end">

                                                {selectedReportTab > 0 ? (linkedReports?.[selectedReportTab - 1]?.reportId?.settings?.showTogleToTable && linkedReports?.[selectedReportTab - 1]?.reportId?.chartType !== 'table' ?
                                                    <MButton className='report-graph-icon-type' onClick={convertToTable} title='Toggle View'>
                                                        {linkedReports?.[selectedReportTab - 1]?.reportId?.toggleToTable ? <GraphIcon /> : <TableIcon />}
                                                    </MButton> : null) :
                                                    settings?.showTogleToTable && chartType !== 'table' ?
                                                        <MButton className='report-graph-icon-type' onClick={convertToTable} title='Toggle View'>
                                                            {toggleToTable ? <GraphIcon /> : <TableIcon />}
                                                        </MButton> : null}
                                            </Box>

                                            {linkedReportsViewType === 'CAROUSEL' && linkedReports?.length ?
                                                <Box className={`number_chart_card_carousel ` + settings?.numberChartTemplate?.template} ref={chartContainerRef}>
                                                    <Box className={`chart-carousel ` + (isMobileView() ? 'chart-carousel-mobile' : ``)} sx={{ width: '100%', height: '100%' }}>
                                                        <Box className='number_chart_carousel_heading'>
                                                            <Typography variant="h6" className="number_chart_carousel_title" title={reportDetails?.reportDetails?.reportName} 
                                                            >{handleStringLength(reportDetails?.reportDetails?.reportName, NumberChartTitleLength)}</Typography>
                                                            <Typography variant="body2" className="number_chart_carousel_subtitle" title={reportDetails?.reportDetails?.description} 
                                                            >{handleStringLength(reportDetails?.reportDetails?.description, NumberChartDescriptionLength)}</Typography>
                                                        </Box>
                                                        {
                                                        reportDetails?.reportDetails?.chartType === 'number'
                                                            ?   <Slider
                                                                    speed={500}
                                                                    arrows={isMobileView() ? false : true}
                                                                    slidesToScroll={1}
                                                                    //slidesToShow={(window.innerWidth < 1024) ? (isMobileView() ? 1.1 : 2.1) : (window.innerWidth < 1600 ? 3.5 : 4.5)}
                                                                    // slidesToShow={(isMobileView() 
                                                                    //                     ? linkedReportsViewCountMobile 
                                                                    //                     : ((settings?.numberChartTemplate?.template === 'template2')
                                                                    //                         ? ((linkedReportsViewCount > (chartContainerRef?.current?.clientWidth/(215+parseInt(reportCarouselCardSpacing)))) ? (chartContainerRef?.current?.clientWidth/(215+parseInt(reportCarouselCardSpacing))) : linkedReportsViewCount)
                                                                    //                         : linkedReportsViewCount
                                                                    //                     )
                                                                    //                 ) ?? 1}
                                                                    slidesToShow={(isMobileView() 
                                                                                        ? linkedReportsViewCountMobile 
                                                                                        : ((settings?.numberChartTemplate?.template === 'template2')
                                                                                            ? (chartContainerWidth /((215 + (reportHasCarouselCardElevation ? 40 : 0)) + parseInt(reportCarouselCardSpacing))) // 32px is left & right padding. 8px for elevation margin between
                                                                                            : linkedReportsViewCount
                                                                                        )
                                                                                    ) ?? 1}
                                                                    centerMode={false}
                                                                    swipeToSlide={true}
                                                                    infinite={false}
                                                                    centerPadding={isMobileView() ? '10px' : '20px'}
                                                                    nextArrow={isMobileView() ? null : <CarouselNextArrow />}
                                                                    prevArrow={isMobileView() ? null : <CarouselPrevArrow />}
                                                                >
                                                                    {reportDetails?.reportDetails && validateMeasuresDimension(reportDetails?.reportDetails) ? (
                                                                        <Box className={"carousel_card " + settings?.numberChartTemplate?.template}>
                                                                            <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
                                                                                <Box className='number_chart_card_heading'>
                                                                                    {
                                                                                    reportDetails?.reportDetails?.carouselName ? 
                                                                                    <Typography variant="h6" className="number_chart_title" title={reportDetails?.reportDetails?.carouselName}
                                                                                    >{handleStringLength(reportDetails?.reportDetails?.carouselName, NumberChartTitleLength)}</Typography>
                                                                                    : null
                                                                                    }
                                                                                    {
                                                                                    reportDetails?.reportDetails?.carouselDescription ? 
                                                                                    <Typography variant="body2" className="number_chart_subtitle" title={reportDetails?.reportDetails?.carouselDescription}
                                                                                    >{handleStringLength(reportDetails?.reportDetails?.carouselDescription, NumberChartDescriptionLength)}</Typography>
                                                                                    : null
                                                                                    }
                                                                                
                                                                                </Box>
                                                                            
                                                                                <Box className="number_chart_value" >
                                                                                    <ReportGraph
                                                                                        reportDetails={mapResponseForQuery(reportDetails.reportDetails)}
                                                                                        getPivotColState={getPivotColState}
                                                                                        gridColumnApi={gridColumnApi}
                                                                                        setGridColumnApi={setGridColumnApi}
                                                                                    />
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>

                                                                    ) : (<EmptyChart chartType={reportDetails?.reportDetails?.chartType} />)}

                                                                    {linkedReports?.map((reportObj, i) => (
                                                                        <Box key={i} className={"carousel_card " + settings?.numberChartTemplate?.template}>
                                                                            <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
                                                                                <Box className='number_chart_card_heading'>
                                                                                    {
                                                                                        reportObj?.carouselName ? 
                                                                                        <Typography variant="h6" title={reportObj?.carouselName} className="number_chart_title"
                                                                                        >{handleStringLength(reportObj?.carouselName, NumberChartTitleLength)}</Typography>
                                                                                        : null
                                                                                    }
                                                                                    {
                                                                                        reportObj?.carouselDescription ? 
                                                                                        <Typography variant="body2" className="number_chart_subtitle" title={reportObj?.carouselDescription}
                                                                                        >{handleStringLength(reportObj?.carouselDescription, NumberChartDescriptionLength)}</Typography>
                                                                                        : null
                                                                                    }
                                                                                
                                                                                </Box>
                                                                                <Box className="number_chart_value" >
                                                                                    <ReportGraph
                                                                                        reportDetails={mapResponseForQuery({ ...reportObj?.reportId, carouselName: reportObj?.carouselName, carouselDescription: reportObj?.carouselDescription })}
                                                                                        getPivotColState={getPivotColState}
                                                                                        gridColumnApi={gridColumnApi}
                                                                                        setGridColumnApi={setGridColumnApi}
                                                                                    />
                                                                                </Box>
                                                                                    
                                                                            </Box>
                                                                        </Box>

                                                                    ))}

                                                                </Slider>


                                                            : <>
                                                                <Box className='re-carousel-wrapper'>
                                                                    <Swiper
                                                                        spaceBetween={parseInt(reportCarouselCardSpacing)}
                                                                        slidesPerView={(isMobileView() ? linkedReportsViewCountMobile : linkedReportsViewCount) ?? 1}
                                                                        modules={[Navigation]}
                                                                        navigation={isMobileView() ? false : {
                                                                        prevEl: ".swiper-prev-arrow",
                                                                        nextEl: ".swiper-next-arrow",
                                                                        }}
                                                                        className='swiper-slider'
                                                                        >
                                                                        {reportDetails?.reportDetails && validateMeasuresDimension(reportDetails?.reportDetails) ? (
                                                                            <SwiperSlide key={reportDetails?.reportId?._id} >
                                                                                <Box className={"carousel_card " + settings?.numberChartTemplate?.template}>
                                                                                    <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
                                                                                        <Box className='number_chart_card_heading'>
                                                                                            {
                                                                                            reportDetails?.reportDetails?.carouselName ? 
                                                                                            <Typography variant="h6" className="number_chart_title" title={reportDetails?.reportDetails?.carouselName}
                                                                                            >{handleStringLength(reportDetails?.reportDetails?.carouselName, NumberChartTitleLength)}</Typography>
                                                                                            : null
                                                                                            }
                                                                                            {
                                                                                            reportDetails?.reportDetails?.carouselDescription ? 
                                                                                            <Typography variant="body2" className="number_chart_subtitle" title={reportDetails?.reportDetails?.carouselDescription}
                                                                                            >{handleStringLength(reportDetails?.reportDetails?.carouselDescription, NumberChartDescriptionLength)}</Typography>
                                                                                            : null
                                                                                            }
                                                                                        
                                                                                        </Box>
                                                                                    
                                                                                        <Box className="number_chart_value" >
                                                                                            <ReportGraph
                                                                                                reportDetails={mapResponseForQuery(reportDetails.reportDetails)}
                                                                                                getPivotColState={getPivotColState}
                                                                                                gridColumnApi={gridColumnApi}
                                                                                                setGridColumnApi={setGridColumnApi}
                                                                                            />
                                                                                        </Box>
                                                                                    </Box>
                                                                                </Box>
                                                                            </SwiperSlide>
                                                                        ) : (<SwiperSlide key={reportDetails?.reportId?._id} ><EmptyChart chartType={reportDetails?.reportDetails?.chartType} /></SwiperSlide>)}
                                    
                                                                        {linkedReports?.map((reportObj, i) => (
                                                                            <SwiperSlide key={i} >
                                                                                <Box className={"carousel_card " + settings?.numberChartTemplate?.template}>
                                                                                    <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
                                                                                        <Box className='number_chart_card_heading'>
                                                                                            {
                                                                                                reportObj?.carouselName ? 
                                                                                                <Typography variant="h6" title={reportObj?.carouselName} className="number_chart_title"
                                                                                                >{handleStringLength(reportObj?.carouselName, NumberChartTitleLength)}</Typography>
                                                                                                : null
                                                                                            }
                                                                                            {
                                                                                                reportObj?.carouselDescription ? 
                                                                                                <Typography variant="body2" className="number_chart_subtitle" title={reportObj?.carouselDescription}
                                                                                                >{handleStringLength(reportObj?.carouselDescription, NumberChartDescriptionLength)}</Typography>
                                                                                                : null
                                                                                            }
                                                                                        
                                                                                        </Box>
                                                                                        <Box className="number_chart_value" >
                                                                                            <ReportGraph
                                                                                                reportDetails={mapResponseForQuery(reportObj?.reportId)}
                                                                                                getPivotColState={getPivotColState}
                                                                                                gridColumnApi={gridColumnApi}
                                                                                                setGridColumnApi={setGridColumnApi}
                                                                                            />
                                                                                        </Box>
                                                                                            
                                                                                    </Box>
                                                                                </Box>
                                                                            </SwiperSlide>
                                                                        ))}
                                                                    </Swiper>
                                                                    
                                                                    {
                                                                        isMobileView() 
                                                                        ? null
                                                                        : <>
                                                                            <CarouselPrevArrow className="swiper-nav-arrow swiper-prev-arrow " />
                                                                            <CarouselNextArrow className="swiper-nav-arrow swiper-next-arrow" />
                                                                            </>
                                                                    }
                                                                </Box>
                                                            </>

                                                        }
                                                    </Box>
                                                </Box>

                                                : <>
                                                    {linkedReports?.length ? <Tabs
                                                        value={selectedReportTab}
                                                        onChange={viewLinkedReport}
                                                        sx={{ mb: 2 }}
                                                        variant="scrollable"
                                                        scrollButtons="auto"
                                                        aria-label="wrapped label tabs example"
                                                        className='report-graph-tabs-container scrollable-tabs'
                                                        TabIndicatorProps={{
                                                            sx: {
                                                                backgroundColor: 'transparent',
                                                            },
                                                            children: <span />
                                                        }}
                                                    >
                                                        <Tab className="tab-item" value={0}
                                                            label={
                                                                <Grid container alignItems="center" justify="center" className="tab-item-box" >
                                                                    <Box sx={{ width: '100%' }}>
                                                                        <Typography variant='h5' className='tab-item-label' >{tabName ? tabName : reportDetails?.reportDetails?.reportName}</Typography>
                                                                    </Box>
                                                                </Grid>
                                                            }
                                                        />
                                                        {linkedReports?.map((reportObj, i) => (
                                                            <Tab key={i} className="tab-item" value={i + 1}
                                                                label={
                                                                    <Grid container alignItems="center" justify="center" className="tab-item-box">
                                                                        <Box sx={{ width: '100%' }}>
                                                                            <Typography variant='h5' className='tab-item-label' >{reportObj?.tabName ? reportObj?.tabName : reportObj.reportName}</Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                }
                                                            />
                                                        ))}
                                                    </Tabs> : null}

                                                    {selectedReportTab > 0 ? (< ReportGraph
                                                        reportDetails={mapResponseForQuery(linkedReports?.[selectedReportTab - 1]?.reportId)}
                                                        getPivotColState={getPivotColState}
                                                        gridColumnApi={gridColumnApi}
                                                        setGridColumnApi={setGridColumnApi}
                                                    />) : reportDetails?.reportDetails && validateMeasuresDimension(reportDetails?.reportDetails) ? (
                                                        <ReportGraph
                                                            reportDetails={mapResponseForQuery(reportDetails.reportDetails)}
                                                            getPivotColState={getPivotColState}
                                                            gridColumnApi={gridColumnApi}
                                                            setGridColumnApi={setGridColumnApi}
                                                        />
                                                    ) : (
                                                        <EmptyChart chartType={reportDetails?.reportDetails?.chartType} />
                                                    )}
                                                </>}
                                        </Box>
                                    </Grid>
                                </MainStyle>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </MainStyleWrapper>
        </RootStyle>
    )
}
